import {createAction, props} from '@ngrx/store';
import {Campaign, Invite, Player} from 'gamesis-story-client';

export const loadMe = createAction('[Player] Load Me');
export const loadPlayers = createAction('[Player] Load Players');
export const loadPlayerSuccess = createAction('[Player] Load Player Success', props<{ player: Player }>());
export const loadPlayersSuccess = createAction('[Player] Load Players Success', props<{ players: Player[] }>());
export const loadInvitesSuccess = createAction('[Player] Load Invites Success', props<{ invites: Invite[] }>());
export const updateMe = createAction('[Player] Update Me', props<{ name: string }>());
export const deletePlayer = createAction('[Player] Delete Player', props<{ id: string }>());
export const deletePlayerSuccess = createAction('[Player] Delete Player Success');
export const revokeInvite = createAction('[Player] Revoke Invite', props<{ id: string }>());
export const revokeInviteSuccess = createAction('[Player] Revoke Invite Success');
export const toggleGM = createAction('[Player] Toggle GM', props<{ player: Player }>());
export const toggleGMSuccess = createAction('[Player] Toggle GM Success');
export const createInvite = createAction('[Player] Invite');
export const createInviteSuccess = createAction('[Player] Invite Success', props<{ invite: Invite }>());
export const leaveCampaign = createAction('[Player] Leave');
export const joinCampaign = createAction('[Player] Join', props<{ code: string }>());
export const joinCampaignSuccess = createAction('[Player] Join Success', props<{ campaign: Campaign }>());
export const playerFailure = createAction('[Player] Player Failure', props<{ error: any }>());
